import { Modal } from "antd";
import { curSym, pipViewDate } from "../../../../utils/pip";
import StatusCol from "../../../table/StatusCol";

const ConetentDetails = ({ isModal, setIsModal, data }) => {

  const FileView = ({ label, list, single }) => {
    return (
      <>
        <div className="mt-3">
          <p className="ct_fs_16 mb-1">{label}</p>
          <div className="ct_multiple_img_div ct_custom_scroll d-flex gap-3 mt-3">
            {!single ? list?.length != 0 &&
              list?.map((item, ind) =>
                item.toLowerCase().includes(".pdf") ? (
                  <>
                    <div
                      className="position-relative ct_iframe_hover  "
                      style={{ width: "120px", height: "120px" }}
                    >
                      <iframe
                        src={item}
                        loading="lazy"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      ></iframe>
                      <a
                        href={item}
                        target="_blank"
                        className="ct_pdf_full_view"
                      >
                        <i className="fa-solid fa-eye ct_cursor_pointer text-white"></i>
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="position-relative ct_iframe_hover  "
                      style={{ width: "120px", height: "120px" }}
                    >
                      <div className="ct_document_uploaded_img">
                        <img
                          src={item || ""}
                          alt=""
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      </div>
                      <a
                        href={item}
                        target="_blank"
                        className="ct_pdf_full_view"
                      >
                        <i className="fa-solid fa-eye ct_cursor_pointer text-white"></i>
                      </a>
                    </div>
                  </>
                )
              )
              :
              <div
                className="position-relative ct_iframe_hover  "
                style={{ width: "120px", height: "120px" }}
              >
                <div className="ct_document_uploaded_img">
                  <img
                    src={single || ""}
                    alt=""
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                </div>
                <a
                  href={single}
                  target="_blank"
                  className="ct_pdf_full_view"
                >
                  <i className="fa-solid fa-eye ct_cursor_pointer text-white"></i>
                </a>
              </div>
            }
          </div>
        </div>
      </>
    );
  };

  return (
    <Modal
      className=""
      visible={isModal}
      onCancel={() => {
        setIsModal(false);
      }}
      centered={true}
      footer={null}
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body px-4 pb-5">
            <div>
              <h4 class="mb-1 ct_fs_20">Content Details</h4>
            </div>

            <ul className="ct_webinar_grid_2 mt-4">
              <li>
                <p className="mb-0 ct_fs_14">Title </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.title || "#N/A"}
                </p>
              </li>
              <li>
                <p className="mb-0 ct_fs_14">Content Type </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.content_type || "#N/A"}
                </p>
              </li>
              <li>
                <p className="mb-0 ct_fs_14">Visibility </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.visibility || "#N/A"}
                </p>
              </li>
              <li>
                <p className="mb-0 ct_fs_14">Status </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {/* {data?.status || "#N/A"} */}
                  <StatusCol type="resourceContent" status={data?.status} />
                </p>
              </li>

              <li>
                <p className="mb-0 ct_fs_14">Short Description </p>
                <p className="mb-0 ct_fs_14 ct_grey_text ct_para_scroll ct_custom_scroll">
                  {data?.short_description || "#N/A"}
                </p>
              </li>
              <li>
                <p className="mb-0 ct_fs_14">Submitted On </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {pipViewDate(data?.created_at)}
                </p>
              </li>
              {data?.image && <FileView label="Thumbnail Image" single={data?.image} list={[]} />}
              <FileView label="Upload File" list={data?.files?.map((item) => item?.file) || []} />
            </ul>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConetentDetails;
